import { Grid } from '@mantine/core';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Paper } from '../../../components/Paper';
import { Stat } from '../../../components/Stat';
import { queryWithFilter } from '../../../util/api/queryWithFilter';
import type { FilterDto } from '../../../util/types/FilterDto';
import type { StatDto } from '../types/StatDto';

interface OverviewProps {
	filter: FilterDto;
}

export function Overview({ filter }: OverviewProps) {
	const { organisation } = useParams();
	const [isReady, setIsReady] = useState(false);

	useEffect(() => {
		setIsReady(true);
	}, []);

	const grossSalesQuery = queryWithFilter<StatDto>(
		`${organisation}/dashboard-stats/gross-sales`,
		filter,
		isReady,
	);

	const totalTransactionsQuery = queryWithFilter<StatDto>(
		`${organisation}/dashboard-stats/total-transactions`,
		filter,
		isReady,
	);

	const totalVatQuery = queryWithFilter<StatDto>(
		`${organisation}/dashboard-stats/total-vat`,
		filter,
		isReady,
	);

	const voidsAndNoSalesQuery = queryWithFilter<StatDto>(
		`${organisation}/dashboard-stats/voids-and-no-sales`,
		filter,
		isReady,
	);

	const hourlyTransactionsQuery = queryWithFilter<StatDto>(
		`${organisation}/dashboard-stats/average-hourly-transactions`,
		filter,
		isReady,
	);

	return (
		<Grid>
			<Grid.Col span={2.4} h={'100%'}>
				<Paper>
					<Stat
						isLoading={grossSalesQuery.isLoading}
						stat={grossSalesQuery.data?.value}
						isFinance
						h={'5vh'}
						label={'Gross Sales'}
					/>
				</Paper>
			</Grid.Col>

			<Grid.Col span={2.4}>
				<Paper>
					<Stat
						isLoading={totalTransactionsQuery.isLoading}
						stat={totalTransactionsQuery.data?.value}
						label={'Total Transactions'}
					/>
				</Paper>
			</Grid.Col>

			<Grid.Col span={2.4}>
				<Paper>
					<Stat
						isLoading={totalVatQuery.isLoading}
						stat={totalVatQuery.data?.value}
						label={'Total VAT'}
						isFinance
					/>
				</Paper>
			</Grid.Col>

			<Grid.Col span={2.4}>
				<Paper>
					<Stat
						isLoading={voidsAndNoSalesQuery.isLoading}
						stat={voidsAndNoSalesQuery.data?.value}
						label={'Voids and No Sales'}
					/>
				</Paper>
			</Grid.Col>

			<Grid.Col span={2.4}>
				<Paper>
					<Stat
						isLoading={hourlyTransactionsQuery.isLoading}
						stat={hourlyTransactionsQuery.data?.value}
						label={'Av. Transactions/Hr'}
						titleProps={{
							info: 'Assumes branches are open for 48.1 hours a week (UK average)',
						}}
					/>
				</Paper>
			</Grid.Col>
		</Grid>
	);
}
